import { MainLayout } from "@/components/MainLayout";
import { SEO } from "@/components/SEO";

export default function CarriersPage() {
  return (
    <MainLayout>
      <SEO 
        title="Transportadoras"
        description="Gerencie transportadoras"
        keywords="transportadoras, serviços"
      />
      <div className="section-delimited">
        <h1 className="text-2xl font-bold mb-4">Transportadoras</h1>
        <p className="text-muted-foreground">Página em desenvolvimento</p>
      </div>
    </MainLayout>
  );
}

